export const USER_TAGS = {
    USERS_LIST: "UsersList",
    USER_DETAILS: "UserDetails",
    GET_ME: "GetMe",
    SELLER_COMPANY_DETAILS: "getSellerCompanyDetails",
} as const;